import React from 'react'
import PartygroupsForm from './PartygroupsForm'

const NewPartygroupPage = () => {
  return (
    <>
     <PartygroupsForm formType='create' currentPartygroupId={null} ></PartygroupsForm>
    </>
  )
}

export default NewPartygroupPage
